import React from 'react';
import copyToClipboard from '../../utils/clipboardUtils';
import IconButton from '../common/IconButton';
import useI18n from '../../hooks/useI18n';

const ShareLink: React.FC<{ link: string }> = ({ link }) => {
  const { t } = useI18n();

  const handleCopy = () => {
    copyToClipboard(link, t('toast.linkCopied'), t('toast.linkCopiedError'));
  };

  return (
    <>
      <div className="flex justify-center">
        <span className="text-neutral-500 text-xs">
          {t('links.orShareWithLink')}
        </span>
      </div>
      <div className="flex items-center py-3 px-4 my-5 rounded-3xl bg-[#F4F4F4] justify-between">
        <span>{link}</span>
        <IconButton
          tooltip={String(t('links.copy'))}
          src="/assets/svgs/fi_copy.svg"
          onClick={handleCopy}
          effectDarkness={2}
          className="bg-white size-50 p-2"
        />
      </div>
    </>
  );
};

export default ShareLink;
